// Денежные и десятичные поля ввода. Поле `type="number"` в браузере с английским языком
// читает «1234,56» как 123456 и не принимает «1 234 567,89», скопированное из 1С или
// Excel, поэтому суммы и ставки вводятся текстом и разбираются здесь.

const SPACES = /[\s  ]/g;

/**
 * Сумма из поля ввода: «1 234 567,89», «1234567.89», «12 500 руб.». Пусто или
 * не число — `null`. Копейки округляются, как на сервере.
 */
export function parseMoney(raw: string): number | null {
  const s = raw
    .replace(SPACES, '')
    .replace(/(₽|руб\.?|р\.)$/i, '')
    .replace(',', '.');
  if (!/^\d+(\.\d+)?$/.test(s)) return null;
  const n = Number(s);
  return Number.isFinite(n) ? Math.round(n * 100) / 100 : null;
}

/** Число в поле ввода: 1234.5 → «1 234,50» — его же разберёт `parseMoney`. */
export function moneyInput(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '';
  return n.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Ставка или доля из поля ввода: «18,25», «18.25 %», «0». Пусто или не число — `null`. */
export function parseDecimal(raw: string): number | null {
  const s = raw.replace(SPACES, '').replace(/%$/, '').replace(',', '.');
  if (!/^\d+(\.\d+)?$/.test(s)) return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

/** Ставка в поле ввода: 18.25 → «18,25», ноль — «0». */
export function decimalInput(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '';
  return String(n).replace('.', ',');
}
